<script lang="ts">
  import { twMerge } from 'tailwind-merge';

  let clazz = '';
  export { clazz as class };
</script>

<hr class={twMerge(`border-t-0 border-b border-gray-100 w-full ${clazz}`)} />
